import propTypes from 'prop-types';
import React, {Component} from 'react';
import {ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';

export default class MultiItemStatusBarItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listItemHover: false,
    };
  }

  onFileEnter = () => {
    this.setState({listItemHover: true});
  };

  onFileLeave = () => {
    this.setState({listItemHover: false});
  };

  render() {
    const {
      thumbUrl,
      primaryText,
      secondaryText,
      rightIconClick,
      rightIconButton,
      rightIconTooltip,
      tooltipPosition,
      tooltipStyles,
      id,
      ...otherProps
    } = this.props;
    const addTooltip = {};
    if (rightIconTooltip) {
      addTooltip.tooltip = rightIconTooltip;
      addTooltip.tooltipStyles = tooltipStyles;
    }
    if (tooltipPosition) {
      addTooltip.tooltipPosition = tooltipPosition;
    }
    return (
      <div>
        <ListItem
          id={id}
          {...otherProps}
          leftAvatar={
            <Avatar style={{borderRadius: 0, backgroundImage: `url(${thumbUrl})`, backgroundSize: 'cover'}} />
          }
          rightIconButton={
            <IconButton onClick={rightIconClick} {...addTooltip}>
              {rightIconButton[rightIconButton[1] && this.state.listItemHover ? 1 : 0]}
            </IconButton>
          }
          primaryText={primaryText}
          secondaryText={secondaryText}
          onMouseEnter={this.onFileEnter}
          onMouseLeave={this.onFileLeave}
        />
        <Divider />
      </div>
    );
  }
}

MultiItemStatusBarItem.propTypes = {
  rightIconButton: propTypes.array,
  thumbUrl: propTypes.string,
  primaryText: propTypes.string,
  secondaryText: propTypes.string,
};

MultiItemStatusBarItem.defaultProps = {
  tooltipStyles: {top: 22},
};
